// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "c2755a157-dirty",
    "hash": "c2755a157",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c2755a157-dirty",
    "semverString": null,
    "version": "2.10.11",
    "buildNumber": 1
};
/* tslint:enable */
